<template>
  <div>
    <header class="cd-main-header">
      <div class="container">
        <div class="row">
          <!-- <router-link :to="{ name: 'home' }" tag="a" class="cd-logo" style="margin-right:200px">
            <img :src="this.config.imgServer + 'logo.png'" alt="Logo" />
          </router-link> -->
          <nav class="cd-nav">
            <ul id="cd-primary-nav" class="cd-primary-nav is-fixed font-text">
              <li>
                <router-link
                  :to="{ name: 'home' }"
                  tag="a"
                  @click.native="dianji()"
                  >网站首页</router-link
                >
              </li>
              <li>
                <router-link
                  :to="{ name: 'curriculum' }"
                  tag="a"
                  @click.native="dianji()"
                  >产品中心</router-link
                >
              </li>
              <li>
                <router-link
                  :to="{ name: 'newslist' }"
                  tag="a"
                  @click.native="dianji()"
                  >新闻中心</router-link
                >
              </li>
              <li>
                <router-link
                  :to="{ name: 'about' }"
                  tag="a"
                  @click.native="dianji()"
                  >关于我们</router-link
                >
              </li>
              <li>
                <router-link
                  :to="{ name: 'contact' }"
                  tag="a"
                  @click.native="dianji()"
                  >联系我们</router-link
                >
              </li>
              <li>
                <router-link
                  :to="{ name: 'product' }"
                  tag="a"
                  @click.native="dianji()"
                  >招聘信息</router-link
                >
              </li>
              <li @click="dianjixiazai()">
                <a
                  target="blank"
                  href="谷歌浏览器下载.rar"
                  download="谷歌浏览器下载.rar"
                >
                  插件下载
                </a>
              </li>
              <li v-if="!pc">
                <a
                  target="blank"
                  href="https://sdzzdzkj.com/img/apk/zhzsjxpt_v1.0.004zzv3.apk" download="zhzsjxpt_v1.0.004zzv3.apk"
                >
                  下载APP
                </a>
              </li>
            </ul>
            <!-- primary-nav -->
          </nav>
          <ul class="cd-header-buttons">
            <li>
              <a class="cd-nav-trigger" href="#cd-primary-nav">
                <span></span>
              </a>
            </li>
          </ul>
          <!-- cd-header-buttons -->
          <router-link :to="{ name: 'home' }" tag="a" class="cd-logo">
            <img :src="this.config.imgServer + 'logo.png'" alt="Logo" />
          </router-link>
        </div>
      </div>
    </header>

    <!-- cd-nav -->
  </div>
</template>

<script>
import { jquery } from "jquery";
import "bootstrap";
import "../../../static/js/nav.js";
import "../../../static/js/jquery.aniview.js";
import "../../../static/js/jquery.waypoints.min.js";
import "../../../static/js/jquery.countup.min.js";
import { WOW } from "wowjs";
import "../../../static/js/public.js";

import "../../../static/css/common.css";
import "../../../static/css/swiper.min.css";
// import "../../../static/css/bootstrap.min.css";
import "../../../static/css/nav.css";
import "../../../static/css/animate.min.css";
import "../../../static/css/style.css";

import Swiper from "swiper";

export default {
  data() {
    return {
      pc:true,
    };
  },
  mounted() {
    new Swiper(".banner-container", {
      autoplay: true,
      loop: true,
      navigation: {
        nextEl: ".banner-button-next",
        prevEl: ".banner-button-prev",
      },
    });

    var wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: true,
      live: true,
    });
    wow.init();
    if (!this._isMobile()) {
      this.pc = true;
    } else {
      this.pc = false;
    }
    var nav = $(".cd-main-header"); //得到导航对象
    var win = $(window); //得到窗口对象
    var sc = $(document); //得到document文档对象。
    win.scroll(function () {
      if (sc.scrollTop() >= 60) {
        nav.addClass("active");
        // $(".navTmp").fadeIn();
      } else {
        nav.removeClass("active");
        // $(".navTmp").fadeOut();
      }
    });
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    menuclick(type) {
      // console.log(type);
      this.$router.push({
        name: "newslist",
      });
    },
    dianji() {
      if (this.isMobiles() != null) {
        //alert(this.isMobiles());
        event.preventDefault();
        if ($(".cd-main-content").hasClass("nav-is-visible")) {
          this.closeNav();
          $(".cd-overlay").removeClass("is-visible");
        } else {
          $(this).addClass("nav-is-visible");
          $(".cd-primary-nav").addClass("nav-is-visible");
          $(".cd-main-header").addClass("nav-is-visible");
          $(".cd-main-content")
            .addClass("nav-is-visible")
            .one(
              "webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend",
              function () {
                $("body").addClass("overflow-hidden");
              }
            );
          toggleSearch("close");
          $(".cd-overlay").addClass("is-visible");
        }
      }
    },
    dianjixiazai() {
      if (this.isMobiles() != null) {
        //alert(this.isMobiles());
        event.preventDefault();
        if ($(".cd-main-content").hasClass("nav-is-visible")) {
          this.closeNav();
          $(".cd-overlay").removeClass("is-visible");
        } else {
          $(this).addClass("nav-is-visible");
          $(".cd-primary-nav").addClass("nav-is-visible");
          $(".cd-main-header").addClass("nav-is-visible");
          $(".cd-main-content")
            .addClass("nav-is-visible")
            .one(
              "webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend",
              function () {
                $("body").addClass("overflow-hidden");
              }
            );
          toggleSearch("close");
          $(".cd-overlay").addClass("is-visible");
        }
      }
      let link = document.createElement("a"); // 创建a标签
      link.style.display = "none";
      link.href = "谷歌浏览器下载.rar"; // 设置下载地址
      link.setAttribute("download", ""); // 添加downLoad属性
      document.body.appendChild(link);
      link.click();
    },
    closeNav() {
      $(".cd-nav-trigger").removeClass("nav-is-visible");
      $(".cd-main-header").removeClass("nav-is-visible");
      $(".cd-primary-nav").removeClass("nav-is-visible");
      $(".has-children ul").addClass("is-hidden");
      $(".has-children a").removeClass("selected");
      $(".moves-out").removeClass("moves-out");
      $(".cd-main-content")
        .removeClass("nav-is-visible")
        .one(
          "webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend",
          function () {
            $("body").removeClass("overflow-hidden");
          }
        );
    },
    isMobiles() {
      var flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/webTop/webTopMenu.vue